import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail, Phone, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-black/10 bg-cream-alt mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Link to="/" className="font-display font-bold tracking-tighter text-3xl text-ink">
            veventex<span className="text-ember">.</span>
          </Link>
          <p className="mt-4 text-ink-muted max-w-sm leading-relaxed">
            A Sydney-based software engineering studio shipping resilient cross-platform
            products and trustworthy AI systems.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono text-[10px] tracking-widest uppercase text-ink-muted mb-4">
            Studio
          </div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/services" className="hover:text-ember transition-colors">Services</Link></li>
            <li><Link to="/articles" className="hover:text-ember transition-colors">Articles</Link></li>
            <li><Link to="/about" className="hover:text-ember transition-colors">About</Link></li>
            <li><Link to="/contact" className="hover:text-ember transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="font-mono text-[10px] tracking-widest uppercase text-ink-muted mb-4">
            Contact
          </div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <Mail size={16} className="mt-0.5 text-ink-muted" strokeWidth={1.5} />
              <a
                href="mailto:info@veventex.com.au"
                data-testid="footer-email"
                className="hover:text-ember transition-colors"
              >
                info@veventex.com.au
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Phone size={16} className="mt-0.5 text-ink-muted" strokeWidth={1.5} />
              <a
                href="tel:+61414490141"
                data-testid="footer-phone"
                className="hover:text-ember transition-colors"
              >
                +61 414 490 141
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={16} className="mt-0.5 text-ink-muted" strokeWidth={1.5} />
              <span>Sydney, Australia</span>
            </li>
            <li className="flex items-start gap-2">
              <Linkedin size={16} className="mt-0.5 text-ink-muted" strokeWidth={1.5} />
              <a
                href="https://www.linkedin.com/company/veventex"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                className="hover:text-ember transition-colors"
              >
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-black/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row gap-2 justify-between text-xs text-ink-muted font-mono">
          <div>© {new Date().getFullYear()} VEVENTEX PTY LTD</div>
          <div>ENGINEERED IN SYDNEY · DEPLOYED EVERYWHERE</div>
        </div>
      </div>
    </footer>
  );
}
